// src/modules/auth/actions/loginAction.ts
import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { LoginInterface } from "../interfaces/login.interface";

export async function loginAction(
  identifier: string,
  password: string
): Promise<ApiResponse<LoginInterface>> {
  const { data } = await apiClient.post<LoginInterface>(
    "/auth/login",
    { 
      identifier, 
      password 
    }
  );
  
  return {
    status: 200,
    data,
    message: "Inicio de sesión exitoso",
  };
}